// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__Viz_W","legacyBtn":"MutateMid_legacyBtn__29pmX"};